import { createMuiTheme } from '@material-ui/core/styles';

const IchhyaTheme = createMuiTheme({
  typography: {
    fontFamily: [
      'Noto Sans',
      '-apple-system',
      'BlinkMacSystemFont',
      'Noto Sans',
      'Roboto',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  palette: {
    text: {
      primary: '#00000',
      secondary: '#ffffff',
    },
    primary: {
      main: '#ffffff',
      light: '#737492',
      dark: '#1e223a',
      contrastText: '#000000',
    },
    secondary: {
      main: '#009688',
      light: '#009688',
      dark: '#009688',
      contrastText: '#009688',
    },
  },
  overrides: {
    MuiAppBar: {
      root: {
        boxShadow: 'none',
      },
    },
    MuiFilledInput: {
      input: {
        // padding: '12px 10px 12px 10px',
      },
    },
    MuiTypography: {
      h6: {
        // fontSize: '18px',
        fontWeight: 600,
      },
      body1: {
        fontSize: 18,
        // lineHeight: '1.5rem',
      },
      body2: {
        fontSize: 16,
        // lineHeight: '1.5rem',
      },
    },
  },
});

export { IchhyaTheme };
